import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { builtFor, systemSteps } from '../data/copy';

/**
 * The product's signature: three decisions and the session is ready.
 * Sequential content, so it reads as a numbered flow, not tiles.
 */
export function HowItWorksSection() {
  return <section className="defer-paint w-full bg-white py-10 sm:py-20" aria-labelledby="how-heading" data-id="element-147" data-mp="pjkbgk1j5l62">
      <div className="mx-auto max-w-6xl px-6" data-id="element-148" data-mp="1tg9eh3zpth6">
        <SectionHeading eyebrow="How the operating system works" titleId="how-heading" title={<>
              Three Decisions. <span className="text-gold-text" data-id="element-150" data-mp="auxl7nad7902">Session Ready.</span>
            </>} lead="Practice in 2 hours? Don’t build it from scratch — run the system." data-id="element-149" data-mp="3t00uzlba096t" />

        <ol className="relative mt-8 grid gap-6 sm:mt-14 lg:grid-cols-3 lg:gap-8" data-id="element-151" data-mp="6unda530i8ik">
          {systemSteps.map((item, index) => <li key={item.step} className="relative flex gap-4 lg:block" data-id="element-152" data-mp="1i7pu9190x039" data-mpi={index}>
              <div className="flex items-center gap-4 self-start" data-id="element-153" data-mp="1i9sjhj2cqp6x">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border-2 border-gold bg-navy font-display text-xl font-bold text-gold lg:h-14 lg:w-14 lg:text-2xl" data-id="element-154" data-mp="wa4olwobpw0f">
                  {item.step}
                </span>
                {index < systemSteps.length - 1 ? <span className="hidden h-px flex-1 border-t-2 border-dashed border-line lg:block" aria-hidden="true" data-id="element-155" data-mp="1a9cnspkhl44m" /> : null}
                {index < systemSteps.length - 1 ? <ArrowRightIcon className="hidden h-5 w-5 shrink-0 text-gold-text lg:block" strokeWidth={2.25} aria-hidden="true" data-id="element-156" data-mp="hlgwk0dos4f8" /> : null}
              </div>
              <div data-id="element-157" data-mp="mjieuj3afzpn">
              <h3 className="font-display text-xl font-bold text-navy lg:mt-5 lg:text-2xl" data-id="element-158" data-mp="mj0b71eaqj7p">
                {item.title}
              </h3>
              <p className="mt-1 text-sm leading-relaxed text-body sm:text-base" data-id="element-159" data-mp="3q2bqgqciaeh6">
                {item.detail}
              </p>
              <ul className="mt-2.5 flex flex-wrap gap-1.5 lg:mt-4 lg:gap-2" data-id="element-160" data-mp="3uz26jdob9a2l">
                {item.options.map(option => <li key={option} className="rounded-md border border-line bg-canvas px-2.5 py-1 text-xs font-semibold text-navy" data-id="element-161" data-mp="124bpmjr7mhym">
                    {option}
                  </li>)}
              </ul>
              </div>
            </li>)}
        </ol>

        <div className="mt-8 flex flex-col items-center gap-3 border-t border-line pt-8 sm:flex-row sm:justify-center sm:gap-5" data-id="element-162" data-mp="16wcyrwt2zskf">
          <p className="text-xs font-bold uppercase tracking-widest text-gold-text" data-id="element-163" data-mp="j83gv5yznoyk">
            Built for
          </p>
          <ul className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-sm font-medium text-navy" data-id="element-164" data-mp="ea20wtwv05rb">
            {builtFor.map((audience, index) => <li key={audience} className="flex items-center gap-4" data-id="element-165" data-mp="n95ks03uop6v" data-mpi={index}>
                {index > 0 ? <span className="h-1 w-1 rounded-full bg-gold-text" aria-hidden="true" data-id="element-166" data-mp="23n5f8vjxfmmq" /> : null}
                {audience}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}